import React from "react";
import iconSend from "../../assets/images/iconSend.svg";

function ChatInput({ showFeedback, inputValue, typing, textAreaRef, onChange, onKeyPress, onSend }) {
  return (
    <div className="bot-footer">
      {!showFeedback && (
        <div className="chat-input-wrapper">
          <div className="chat-input-row">
            <textarea
              ref={textAreaRef}
              type="text"
              className="chat-input"
              placeholder={typing ? "DIVA is typing…" : "Message DIVA…"}
              onChange={onChange}
              onKeyPress={onKeyPress}
              value={inputValue}
              disabled={typing}
              rows={1}
              aria-label="Message input"
            />
          </div>
          <div className="chat-send-icon">
            <button
              type="button"
              className="send-btn"
              onClick={onSend}
              disabled={typing || !inputValue.trim()}
              aria-label="Send message"
            >
              <img className="chatbot-send-button" src={iconSend} alt="" />
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default ChatInput;
